import { useEffect, useState } from "react";
import fetchData from "../custom_functions/fetchData";
import { url } from "../utils/config";
import AddSpecialEquipment from "../modals/AddSpecialEquipment";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnOne, title } from "../utils/style";


function Equipments() {
    const [equipments, setEquipments] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)

    useEffect(() => {
        fetchData(url + '/equipments', (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }, (data) => { setEquipments(data.data) })
    }, [reloadTable])

    return (
        <div className="p-4">
            {
                showForm && <AddSpecialEquipment setShowForm={setShowForm} reload={setReloadTable} />
            }
            <div className="flex justify-between pt-2">
                <div className={title}>Equipment</div>
                <div className='flex justify-end mb-2'>
                    <Button className={btnOne} name={'Add Equipment'} clickHandler={() => setShowForm(!showForm)} />
                </div>
            </div>
            <div className="grid grid-cols-5 gap-5">
                {equipments.length > 0 &&
                    equipments.map((equipment, index) => (
                        <div
                            key={index}
                            className="p-4 flex flex-col items-center rounded-xl shadow-lg transition-transform duration-300 hover:scale-105"
                        >
                            <div className="flex">
                                <img
                                    src={`${url}/${equipment.imageUrl}`}
                                    alt={equipment.name}
                                    className="cursor-pointer h-40 w-48 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                                />
                            </div>
                            <div className="text-md font-semibold py-2 text-gray-800 text-center">
                                {equipment.name}
                            </div>
                        </div>
                    ))}
            </div>

        </div>
    )
}

export default Equipments;